export const regionsNames = {
  PBE: 'PBE',
};
